export default {
  'step3.firstChoice': 'Mon entreprise est immatriculé',
  'step3.secondChoice': 'Mon entreprise est en cours de création',
  'step3.noRadio': 'Veillez choisir le statut de votre entreprise',
};
